import Header from "../../components/Header";
import "./styles.css";

import Button from "../../components/Button";
import { OpenInBrowser } from "@mui/icons-material";
import Footer from "../../components/Footer";

const contactURL = "https://api.whatsapp.com/send/?phone=5511919829965";

export default function HandleRequestAccountDeletion() {
  function handleGoToAccountReletion() {
    if (window.top !== window.self) {
      window.open(contactURL, "_blank"); // Abre a URL em uma nova aba
    } else {
      window.location.href = contactURL;
    }
  }

  return (
    <main>
      <Header links={[]} />

      <div className="body-container">
        <h1 className="center mt-4">
          Deseja solicitar a exclusão dos dados do seu app?
        </h1>
        <h4 className="mt-1 center">
          Entre em contato com o nosso time através do botão abaixo, e informe
          qual é o seu email atual.
        </h4>
        <Button.Main
          className="center my-4"
          onPress={handleGoToAccountReletion}
          text="Solicitar exclusão dos dados"
          rightIcon={<OpenInBrowser />}
        />

        <h3 className="mt-4 mb-1">Quais dados serão excluídos?</h3>
        <li className="ml-1">Dados pessoais, como email, telefone e nome;</li>
        <li className="ml-1">Posts publicados pelo usuário;</li>
        <li className="ml-1">Comentários e publicações na comunidade.</li>
      </div>

      <Footer title={<div className="mt-3"></div>} />
    </main>
  );
}
